import { ChangeDetectorRef, EnvironmentInjector, inject, Pipe, PipeTransform } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { getLocalizedDuration } from "@shared/functions/get-localized-duration";
import { Duration } from "date-fns";
import { isEqual } from "es-toolkit";
import { distinctUntilChanged, filter, Subject, switchMap, tap } from "rxjs";

@Pipe({
  name: "appDuration",
  standalone: true,
  pure: false
})
export class DurationPipe implements PipeTransform {
  private readonly _duration: Subject<Duration | undefined> = new Subject<Duration | undefined>();

  private readonly _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  private readonly _environmentInjector: EnvironmentInjector = inject(EnvironmentInjector);

  private _latestValue: string = "";

  constructor () {
    this._duration
      .pipe(
        takeUntilDestroyed(),
        filter(Boolean),
        distinctUntilChanged(isEqual),
        switchMap((duration: Duration) => getLocalizedDuration(duration, this._environmentInjector)
          .pipe(
            tap((value: string) => this._updateLatestValue(value))
          ))
      ).subscribe();
  }


  public transform (value: Duration | undefined): string {
    this._duration.next(value);

    return this._latestValue;
  }


  private _updateLatestValue (transformedValue: string): void {
    if (transformedValue === this._latestValue)
      return;

    this._latestValue = transformedValue;
    this._changeDetectorRef.markForCheck();
  }
}
